$(document).ready(function() {

  // Smooth scroll to target

  $('.ani-scroll').click(function(e) {
    e.preventDefault();
    var target = $($(this).attr('href'));

    $('html, body').animate({
      scrollTop: target.offset().top - 110
    }, 800);
  });

  // Scollmagic functionality

  var controller = new ScrollMagic.Controller();
  var scene = new ScrollMagic.Scene({
    triggerElement: ".parallax-car",
    offset: "-200"
  })
  //.setClassToggle(".parallax-car", "car-visible")
  .on('enter',function(){
    setTimeout(function(){
      $('.slide-in-layer').fadeOut(1500);
    },200)
  })
  .on('leave',function(){
    $('.slide-in-layer').fadeIn();
  })
  .addTo(controller);


  // General popup functionality

  $('.close-popup,.popup-overlay').click(function() {
    $('.general-popup').fadeOut();
  })

  // Tabs functionality

  $('.has-tab-nav').each(function() {

    var designTab = $(this).find('.tab-content')
    var designTabNav = $(this).find('.tab-nav').find('a');
    designTab.hide().first().show();
    designTabNav.first().addClass('active');

    designTabNav.click(function(e) {

      e.preventDefault();

      $(this).addClass('active');
      $(this).parent().siblings().find('a').removeClass('active');
      var TabNavIndex = $(this).parent('.columns').index();
      designTab.eq(TabNavIndex).fadeIn().siblings('.tab-content').hide();
    });
  });

  // Match height of car details columns

  $('.car-details').find('.columns').matchHeight({
    byRow: true
  });

  // Accordion functionality

  $('.accordion').each(function() {

    var accordionItem = $(this).find('.accordion-item');
    var accordionContent = $('.accordion-content');
    var accordionTitle = $(this).find(accordionItem).find('.accordion-title');
    accordionItem.find(accordionContent).hide();
    accordionItem.first().find(accordionContent).show().parent().addClass('accordion-open');

    accordionTitle.click(function() {
      $(this).parent().siblings().find(accordionContent).slideUp().parent().removeClass('accordion-open');
      $(this).parent().find(accordionContent).slideToggle().parent().toggleClass('accordion-open');
    });
  });

  // Slick slideshow

  $('.slideshow').slick({
    arrows: true,
    autoplaySpeed: 4500,
    autoplay: true,
    draggable: true,
    lazyLoad: 'ondemand',
    infinite: true,
    dots: true,
//     adaptiveHeight: true,
prevArrow: '<button class="slick-nav-prev slick-nav"><img src="//cdn.shopify.com/s/files/1/1787/5595/t/1/assets/arrow-prev.png"></button>',
nextArrow: '<button class="slick-nav-next slick-nav"><img src="//cdn.shopify.com/s/files/1/1787/5595/t/1/assets/arrow-next.png"></button>'
});

  // Spec boxes

  var specBox = $('.spec-inner')

  var SpecWrapper = $('.spec-boxes-wrapper');

  var finalPrice = [];

  var total = 0

  // Slide keys on the selected spec:

  // E - Entry, C - Comfort, P - Premium
  // BL - Black, DB - Dark Blue, LB - Light Blue
  // R - Roof Bars
  // A - Alloys
  // SW - Spare Wheel  
  
  var slideImages = {
    "E": ["https://cdn.shopify.com/s/files/1/1787/5595/t/1/assets/1_1_entry.jpg",
    "https://cdn.shopify.com/s/files/1/1787/5595/t/1/assets/4_1_entry.jpg",
    "https://cdn.shopify.com/s/files/1/1787/5595/t/1/assets/mb1.jpg"],

    "EBL": ["https://cdn.shopify.com/s/files/1/1787/5595/t/1/assets/1_1_entry.jpg",
    "https://cdn.shopify.com/s/files/1/1787/5595/t/1/assets/4_1_entry.jpg",
    "https://cdn.shopify.com/s/files/1/1787/5595/t/1/assets/mb1.jpg"],

    "EBLSW": ["https://cdn.shopify.com/s/files/1/1787/5595/t/1/assets/1_1_entry.jpg",
    "https://cdn.shopify.com/s/files/1/1787/5595/t/1/assets/4_1_entry_swc.jpg",
    "https://cdn.shopify.com/s/files/1/1787/5595/t/1/assets/mb2.jpg"],

    "EBLR": ["https://cdn.shopify.com/s/files/1/1787/5595/t/1/assets/1_2_entry.jpg",
    "https://cdn.shopify.com/s/files/1/1787/5595/t/1/assets/4_2_entry.jpg",
    "https://cdn.shopify.com/s/files/1/1787/5595/t/1/assets/mb3.jpg"],

    "EBLRSW": ["https://cdn.shopify.com/s/files/1/1787/5595/t/1/assets/1_2_entry.jpg",
    "https://cdn.shopify.com/s/files/1/1787/5595/t/1/assets/4_2_entry_swc.jpg",
    "https://cdn.shopify.com/s/files/1/1787/5595/t/1/assets/mb4.jpg"],

    "EBLA": ["https://cdn.shopify.com/s/files/1/1787/5595/t/1/assets/1_3_entry.jpg",
    "https://cdn.shopify.com/s/files/1/1787/5595/t/1/assets/4_3_entry.jpg",
    "https://cdn.shopify.com/s/files/1/1787/5595/t/1/assets/mb1.jpg"],

    "EBLASW": ["https://cdn.shopify.com/s/files/1/1787/5595/t/1/assets/1_3_entry.jpg",
    "https://cdn.shopify.com/s/files/1/1787/5595/t/1/assets/4_3_entry_swc.jpg",
    "https://cdn.shopify.com/s/files/1/1787/5595/t/1/assets/mb3.jpg"],

    "EBLRA": ["https://cdn.shopify.com/s/files/1/1787/5595/t/1/assets/1_4_entry.jpg",
    "https://cdn.shopify.com/s/files/1/1787/5595/t/1/assets/4_4_entry.jpg",
    "https://cdn.shopify.com/s/files/1/1787/5595/t/1/assets/mb3.jpg"],

    "EBLRASW": ["https://cdn.shopify.com/s/files/1/1787/5595/t/1/assets/1_4_entry.jpg",
    "https://cdn.shopify.com/s/files/1/1787/5595/t/1/assets/4_4_entry_swc.jpg",
    "https://cdn.shopify.com/s/files/1/1787/5595/t/1/assets/mb4.jpg"],

    "C": ["https://cdn.shopify.com/s/files/1/1787/5595/t/1/assets/1_5_comfort.jpg",
    "https://cdn.shopify.com/s/files/1/1787/5595/t/1/assets/4_5_comfort.jpg",
    "https://cdn.shopify.com/s/files/1/1787/5595/t/1/assets/mb5.jpg"],

    "CBL": ["https://cdn.shopify.com/s/files/1/1787/5595/t/1/assets/1_5_comfort.jpg",
    "https://cdn.shopify.com/s/files/1/1787/5595/t/1/assets/4_5_comfort.jpg",
    "https://cdn.shopify.com/s/files/1/1787/5595/t/1/assets/mb5.jpg"],

    "CBLI": ["https://cdn.shopify.com/s/files/1/1787/5595/t/1/assets/1_5_comfort.jpg",
    "https://cdn.shopify.com/s/files/1/1787/5595/t/1/assets/4_5_comfort.jpg",
    "https://cdn.shopify.com/s/files/1/1787/5595/t/1/assets/mb6.jpg"],


    "CBLIA": ["https://cdn.shopify.com/s/files/1/1787/5595/t/1/assets/1_5_comfort.jpg",
    "https://cdn.shopify.com/s/files/1/1787/5595/t/1/assets/4_5_comfort.jpg",
    "https://cdn.shopify.com/s/files/1/1787/5595/t/1/assets/mb6.jpg"],

    "CDB": ["https://cdn.shopify.com/s/files/1/1787/5595/t/1/assets/1_6_comfort.jpg",
    "https://cdn.shopify.com/s/files/1/1787/5595/t/1/assets/4_6_comfort.jpg",
    "https://cdn.shopify.com/s/files/1/1787/5595/t/1/assets/mbl1.jpg"],


    "CDBI": ["https://cdn.shopify.com/s/files/1/1787/5595/t/1/assets/1_6_comfort.jpg",
    "https://cdn.shopify.com/s/files/1/1787/5595/t/1/assets/4_6_comfort.jpg",
    "https://cdn.shopify.com/s/files/1/1787/5595/t/5/assets/mbl2.jpg"],

    "CBLA": ["https://cdn.shopify.com/s/files/1/1787/5595/t/1/assets/1_7_comfort.jpg",
    "https://cdn.shopify.com/s/files/1/1787/5595/t/1/assets/4_7_comfort.jpg",
    "https://cdn.shopify.com/s/files/1/1787/5595/t/1/assets/mb5.jpg"],


    "CBLIA": ["https://cdn.shopify.com/s/files/1/1787/5595/t/1/assets/1_7_comfort.jpg",
    "https://cdn.shopify.com/s/files/1/1787/5595/t/1/assets/4_7_comfort.jpg",
    "https://cdn.shopify.com/s/files/1/1787/5595/t/1/assets/mb6.jpg"],

    "CDBA": ["https://cdn.shopify.com/s/files/1/1787/5595/t/1/assets/1_8_comfort.jpg",
    "https://cdn.shopify.com/s/files/1/1787/5595/t/1/assets/4_8_comfort.jpg",
    "https://cdn.shopify.com/s/files/1/1787/5595/t/1/assets/mbl1.jpg"],

    "CDBIA": ["https://cdn.shopify.com/s/files/1/1787/5595/t/1/assets/1_8_comfort.jpg",
    "https://cdn.shopify.com/s/files/1/1787/5595/t/1/assets/4_8_comfort.jpg",
    "https://cdn.shopify.com/s/files/1/1787/5595/t/5/assets/mbl2.jpg"],

    "CBLR": ["https://cdn.shopify.com/s/files/1/1787/5595/t/1/assets/1_9_comfort.jpg",
    "https://cdn.shopify.com/s/files/1/1787/5595/t/1/assets/4_9_comfort.jpg",
    "https://cdn.shopify.com/s/files/1/1787/5595/t/1/assets/mb5.jpg"],

    "CBLIR": ["https://cdn.shopify.com/s/files/1/1787/5595/t/1/assets/1_9_comfort.jpg",
    "https://cdn.shopify.com/s/files/1/1787/5595/t/1/assets/4_9_comfort.jpg",
    "https://cdn.shopify.com/s/files/1/1787/5595/t/1/assets/mb6.jpg"],


    "CDBR": ["https://cdn.shopify.com/s/files/1/1787/5595/t/1/assets/1_10_comfort.jpg",
    "https://cdn.shopify.com/s/files/1/1787/5595/t/1/assets/4_10_comfort.jpg",
    "https://cdn.shopify.com/s/files/1/1787/5595/t/1/assets/mbl1.jpg"],

    "CDBIR": ["https://cdn.shopify.com/s/files/1/1787/5595/t/1/assets/1_10_comfort.jpg",
    "https://cdn.shopify.com/s/files/1/1787/5595/t/1/assets/4_10_comfort.jpg",
    "https://cdn.shopify.com/s/files/1/1787/5595/t/5/assets/mbl2.jpg"],

    "CBLAR": ["https://cdn.shopify.com/s/files/1/1787/5595/t/1/assets/1_11_comfort.jpg",
    "https://cdn.shopify.com/s/files/1/1787/5595/t/1/assets/4_11_comfort.jpg",
    "https://cdn.shopify.com/s/files/1/1787/5595/t/1/assets/mb5.jpg"],

    "CBLIRA": ["https://cdn.shopify.com/s/files/1/1787/5595/t/1/assets/1_11_comfort.jpg",
    "https://cdn.shopify.com/s/files/1/1787/5595/t/1/assets/4_11_comfort.jpg",
    "https://cdn.shopify.com/s/files/1/1787/5595/t/1/assets/mb6.jpg"],

    "CDBAR": ["https://cdn.shopify.com/s/files/1/1787/5595/t/1/assets/1_12_comfort.jpg",
    "https://cdn.shopify.com/s/files/1/1787/5595/t/1/assets/4_12_comfort.jpg",
    "https://cdn.shopify.com/s/files/1/1787/5595/t/1/assets/mbl1.jpg"],

    "CDBIAR": ["https://cdn.shopify.com/s/files/1/1787/5595/t/1/assets/1_12_comfort.jpg",
    "https://cdn.shopify.com/s/files/1/1787/5595/t/1/assets/4_12_comfort.jpg",
    "https://cdn.shopify.com/s/files/1/1787/5595/t/5/assets/mbl2.jpg"],

    "P": ["https://cdn.shopify.com/s/files/1/1787/5595/t/1/assets/1_13_premium.jpg",
    "https://cdn.shopify.com/s/files/1/1787/5595/t/1/assets/4_13_premium.jpg",
    "https://cdn.shopify.com/s/files/1/1787/5595/t/1/assets/mb6.jpg"],

    "PBL": ["https://cdn.shopify.com/s/files/1/1787/5595/t/1/assets/1_13_premium.jpg",
    "https://cdn.shopify.com/s/files/1/1787/5595/t/1/assets/4_13_premium.jpg",
    "https://cdn.shopify.com/s/files/1/1787/5595/t/1/assets/mb6.jpg"],

    "PBLI": ["https://cdn.shopify.com/s/files/1/1787/5595/t/1/assets/1_13_premium.jpg",
    "https://cdn.shopify.com/s/files/1/1787/5595/t/1/assets/4_13_premium.jpg",
    "https://cdn.shopify.com/s/files/1/1787/5595/t/1/assets/mb6.jpg"],

    "PDB": ["https://cdn.shopify.com/s/files/1/1787/5595/t/1/assets/1_14_premium.jpg",
    "https://cdn.shopify.com/s/files/1/1787/5595/t/1/assets/4_14_premium.jpg",
    "https://cdn.shopify.com/s/files/1/1787/5595/t/5/assets/mbl2.jpg"],

    "PDBI": ["https://cdn.shopify.com/s/files/1/1787/5595/t/1/assets/1_14_premium.jpg",
    "https://cdn.shopify.com/s/files/1/1787/5595/t/1/assets/4_14_premium.jpg",
    "https://cdn.shopify.com/s/files/1/1787/5595/t/5/assets/mbl2.jpg"],

    "PLB": ["https://cdn.shopify.com/s/files/1/1787/5595/t/1/assets/1_15_premium.jpg",
    "https://cdn.shopify.com/s/files/1/1787/5595/t/1/assets/4_15_premium.jpg",
    "https://cdn.shopify.com/s/files/1/1787/5595/t/5/assets/mlb2.jpg"],

    "PLBI": ["https://cdn.shopify.com/s/files/1/1787/5595/t/1/assets/1_15_premium.jpg",
    "https://cdn.shopify.com/s/files/1/1787/5595/t/1/assets/4_15_premium.jpg",
    "https://cdn.shopify.com/s/files/1/1787/5595/t/5/assets/mlb2.jpg"],

    "PBLR": ["https://cdn.shopify.com/s/files/1/1787/5595/t/1/assets/1_16_premium.jpg",
    "https://cdn.shopify.com/s/files/1/1787/5595/t/1/assets/4_16_premium.jpg",
    "https://cdn.shopify.com/s/files/1/1787/5595/t/1/assets/mb6.jpg"],

    "PBLIR": ["https://cdn.shopify.com/s/files/1/1787/5595/t/1/assets/1_16_premium.jpg",
    "https://cdn.shopify.com/s/files/1/1787/5595/t/1/assets/4_16_premium.jpg",
    "https://cdn.shopify.com/s/files/1/1787/5595/t/1/assets/mb6.jpg"],

    "PDBR": ["https://cdn.shopify.com/s/files/1/1787/5595/t/1/assets/1_17_premium.jpg",
    "https://cdn.shopify.com/s/files/1/1787/5595/t/1/assets/4_17_premium.jpg",
    "https://cdn.shopify.com/s/files/1/1787/5595/t/5/assets/mbl2.jpg"],

    "PDBIR": ["https://cdn.shopify.com/s/files/1/1787/5595/t/1/assets/1_17_premium.jpg",
    "https://cdn.shopify.com/s/files/1/1787/5595/t/1/assets/4_17_premium.jpg",
    "https://cdn.shopify.com/s/files/1/1787/5595/t/5/assets/mbl2.jpg"],

    "PLBR": ["https://cdn.shopify.com/s/files/1/1787/5595/t/1/assets/1_18_premium.jpg",
    "https://cdn.shopify.com/s/files/1/1787/5595/t/1/assets/4_18_premium.jpg",
    "https://cdn.shopify.com/s/files/1/1787/5595/t/5/assets/mlb2.jpg"],

    "PLBIR": ["https://cdn.shopify.com/s/files/1/1787/5595/t/1/assets/1_18_premium.jpg",
    "https://cdn.shopify.com/s/files/1/1787/5595/t/1/assets/4_18_premium.jpg",
    "https://cdn.shopify.com/s/files/1/1787/5595/t/5/assets/mlb2.jpg"],

  };
  
  
  
  SpecWrapper.each(function() {

    var multiSpec = [];

    $(this).find(specBox).on('click', function() {

      var total = 0;
      var selectedEngine = $(this).find('.spec-engine').data('engine');
      var parentWrap = $(this).closest(SpecWrapper);
      var parentWrapIndex = parentWrap.index('.spec-boxes-wrapper');

      // Color unavailable pop-up

      if ($(this).parent().hasClass('unavailable')) {
        var colorWarning = $(this).find('.colour-warning').text();
        $('.spec-popup').find('.popup-copy').html("Sorry, this colour is " + colorWarning + '.');
        $('.spec-popup').fadeIn();
      } else {
        if ($(this).hasClass('active')) {
          $(this).removeClass('active')
        } else {
          if ($(this).hasClass('multi-choice')) {
            $(this).toggleClass('active');
          } else {
            $(this).addClass('active');
            $(this).parent().siblings().find(specBox).removeClass('active');
          }
        };
      }



      var activeWrapper = ($(this).closest(SpecWrapper).index('.spec-boxes-wrapper'));

      // Mobile accept circles

      if ($(window).width() < 1024) {
        var relevantCircle = $('.tab-nav').find('.columns').eq(activeWrapper).find('.accept-circle');

        if ($(this).closest(SpecWrapper).find(specBox).hasClass('active')) {
          relevantCircle.addClass('show-mobile').addClass().fadeIn();
        } else {
          relevantCircle.fadeOut();
        }
      };

      // Enabling and disabling next and prev boxes

      if ($(this).closest(SpecWrapper).find(specBox).hasClass('active')) {
        $('.tab-nav').find('.columns').eq(parentWrapIndex).addClass('activated');

        var target = $('.tab-nav').find('.columns').eq(parentWrapIndex + 1);
        target.addClass('activated');

        setTimeout(function(){
          target.find('a').click()
        },750)

        $('.next-tab').addClass('active');

      } else {
        $('.tab-nav').find('.columns').eq(parentWrapIndex + 1).removeClass('activated');
        $('.tab-nav').find('.columns').eq(parentWrapIndex + 2).removeClass('activated');
        $('.next-tab').removeClass('active');
      }

      // Switching between the tabs with the next button

      $('.next-tab').on(' click', function(e) {
        e.preventDefault();
        $('.tab-nav').find('.columns').eq(parentWrapIndex + 1).find('a').click();
      });

      var prodVariants = $('#product-variants').find('.selector-wrapper').eq(activeWrapper);
      var tabContent = $(this).closest('.tab-content');
      specBoxParent = $(this).parent('.spec-box').index();
      prodVariants.find('select').find('option').eq(specBoxParent).prop('selected', true).parent().trigger('change')

      // Passing selected box value for the order form

      if ($(this).closest(SpecWrapper).find(specBox).hasClass('active')) {

        var selectedSpec = $(this).find('.spec-title').data('spec-title');
        var selectedSeats = $(this).data('seats');

        console.log('selected seats', selectedSeats);

        if ($(this).hasClass('multi-choice')) {

          multiSpec = [];

          $(this).closest(SpecWrapper).find(specBox).each(function() {
            if($(this).hasClass('active')) {
              var selectedSpec = $(this).find('.spec-title').data('spec-title');
              multiSpec.push(selectedSpec);
            }
          });

          $('.product-properties').find('input').eq(activeWrapper).val(multiSpec.join(', '));
        } else {

          $('.product-properties').find('input').eq(activeWrapper).val(selectedSpec);

          if (selectedSeats)
          {
            $('.property-seats').val(selectedSeats);
          }
          
        }

      } else  {
        if ($(this).hasClass('multi-choice')) {
          multiSpec = [];
          $('.product-properties').find('input').eq(activeWrapper).val(multiSpec);
        }
      }


      var spec = $(this).data("spec-title");
      var seats = $(this).data("seats");



      if ($(this).data('spec')) {
        $('.car-details').empty();

        $.each(spec, function(key, value) {
          if (value != '-') {
            $('.car-details').append('<div class="spec-group"><span class="label">' + key + ':</span><span class="spec-title">' + value + '</span></div>');
          }
        });

        $.each(seats, function(key, value) {
          if (value != '-') {
            $('.car-details').append('<div class="spec-group"><span class="label">Seats:</span><span class="spec-title">' + value + '</span></div>');
          }
        });
      }

      // Colour boxes functionality

      if ($(this).data('colours')) {
        var colourSpec = $(this).data('colours');

        var colourBoxes = $('.spec-colours');

        if (!$(this).parent().hasClass('spec-color-box')) {
          colourBoxes.find('.spec-box').addClass('unavailable').find('.colour-info', 'sup').show();
          colourBoxes.find('.spec-box').find('.spec-inner').removeClass('active');
        }

        $.each(colourSpec, function(key, value) {
          colourBoxes.find('.color-' + value).removeClass('unavailable').find('.colour-info').hide();
        });
      }

      // Single option colour box 



      // Extras functionality

      if ($(this).data('extras')) {
        var specExtra = $(this).data('extras');
        $('.extras-boxes').find('.spec-box').hide().find('.spec-inner').removeClass('active');

        $.each(specExtra, function(key, value) {
          $('.extras-boxes').find('.extra-' + value).show();
        });
        

        $('.extra-box:visible').first().addClass('first');
        $('.extra-box:visible').last().addClass('last');

      }
      
      

      // Final price

      var totalPrice = 0;

      $('[data-price]').each(function() {

        if ($(this).hasClass('active')) {
          totalPrice += parseFloat($(this).data('price'));
        }

        totalPriceFormatted = Shopify.formatMoney(totalPrice * 100, "{{amount}} KES");

        $('.final-price').find('.product-price').text(totalPriceFormatted.replace(".00", ""));
        $('.product-total-price').val(totalPriceFormatted.replace(".00", ""));

      });

      $('.extra-listing').empty();

      dataExtraAdd = 0

      $('[data-extra-add]').each(function() {

        var extraSpec = $(this).data('extra-add');


        if ($(this).hasClass('active')) {

          extraSpecFormatted = Shopify.formatMoney($(this).data('price') * 100, "{{amount}} KES");

          dataExtraAdd++

          if (dataExtraAdd == 1) {
            $('.extra-listing').prepend('<span class="data-extra-add-title">Options:</span>');
          } else if (dataExtraAdd == 0) {
            $('.data-extra-add-title').hide();
          }

          $('.extra-listing').append('<div class="spec-group extras">+ ' + extraSpec + ' ' + extraSpecFormatted.replace(".00", ""));
        } else {

        }
      });

      var slidesControl = [];
      var slidesKey;

      $.each($('.spec-inner.active'), function() {
        if ($(this).data('colour-selected')) {
          $('.selected-colour').empty();
          colourSelected = $(this).data('colour-selected');
          $('.selected-colour').append('<div class="spec-group"><span class="label">Colour:</span><span>' + colourSelected + '</span></div>');
        }

        var slickSlideshow = $('.build-heading').find('.slideshow');
        var slideshowHeight = slickSlideshow.height();
        slickSlideshow.css({
          'minHeight': slideshowHeight,
          'overflow': 'hidden'
        });

        if ($(this).data('key')) {
          slidesControl.push($(this).data('key'));
          slidesKey = slidesControl.join("");
          
          console.log('slidesKey', slidesKey);

          var newSlides = slideImages[slidesKey];
          
          if (newSlides) {

            var sidebarImg = newSlides[0];

            if (sidebarImg) {
         
              if ($('.car-photo').hasClass('no-click')) {
                $('.single-option').on('click',function(){
                  var el = $(this);
                  $('.car-photo').find('img').prop('src', el.data('single-option'));
                });
              } else {
                $('.car-photo').find('img').prop('src', sidebarImg);
              }
            }

            console.log('Adding slides', newSlides);

            for(s in newSlides) {
              slickSlideshow.slick('slickAdd','<img src="' + newSlides[s] + '" width="1600" height="531" />');
              
            }
            
            setTimeout(function() {
              slickSlideshow.slick('slickRemove', 0);
              slickSlideshow.slick('slickRemove', 0);
              slickSlideshow.slick('slickRemove', 0);
            }, 100);

          }
          else 
          {
            var defaultSidbarImg = $('.car-photo').find('img').prop('src');
            $('.car-photo').find('img').prop('src', defaultSidbarImg);
          }                    
        }
      });

      var can_proceed = true;

      $('.product-properties .required-input').each(function() {
        if($(this).val() == '') {
          can_proceed = false;
        }
      });

      if (can_proceed == true) {
        $('.pre-order-button').fadeIn();
      } else {
        $('.pre-order-button').fadeOut(); 
      }  
    }); 
});

  // Mobile spec boxes  

  // Full screen menu slide lists

  $('.sliding-list-wrap').find('.slide-list').each(function() {
    $(this).find('.list-title').click(function() {
      $(this).toggleClass('mobile-list-open').parent('.slide-list').siblings().find('.list-title').removeClass('mobile-list-open');
      $(this).parent().find('ul').slideToggle();
      $(this).parent().siblings().find('ul').slideUp();
    });
  });

  // Full screen menu trigger

  $('.mobile-nav').click(function() {
    $('body').toggleClass('menu-open');
    $('.fullscreen-menu-wrap').fadeToggle();
    $('.mobile-over-menu,.top-sticky-nav,.bottom-sticky-nav').toggleClass('over-menu');
  });

  // Mobile gallery

  var mobileGallery = $('.mobile-gallery');
  var mobileBigImage = mobileGallery.find('.big-images').find('img');
  var mobileThumbs = mobileGallery.find('.thumbs').find('img');

  mobileThumbs.click(function(index) {
    var mobileThumbIndex = $(this).index();
    mobileBigImage.eq(mobileThumbIndex).fadeIn().siblings().hide();
  });

  // Main nav dropdown hover - hide secondary nav

  {
    $('.main-nav').find('.dropdown-list').hover(function() {

      $('.bottom-sticky-nav').stop(true, false).fadeOut(200);
    }, function() {
      $('.bottom-sticky-nav').fadeIn(200);
    })
  }

  // NEW MAP

  var location_data = [
  {
    "title": "Nairobi",
    "latlng": "-1.329877,36.867515",
    "handle": "Nairobi",
    "address": "Sameer Business Park, <br/> Block C <br/> Mombasa Road<br/> Nairobi, Kenya <br/>0800-MOBIUS (0800-662487) / Kenya only <br/> +254 719 582 470 <br/> (accessible worldwide / charges may apply) ",
    "type": "sales,service",
    "category": "open"
  },
  {
    "title": "Mombasa",
    "latlng": "-4.051166,39.658001",
    "handle": "Mombasa",
    "address": "Coming Soon",
    "type": "sales,service",
    "category":"coming_soon"
  }
  ];

  function initMap() {
    var center = {
      lat: -1.329877,
      lng: 36.867515
    };

    var styledMapType = new google.maps.StyledMapType([{
      "featureType": "water",
      "elementType": "geometry.fill",
      "stylers": [{
        "color": "#d3d3d3"
      }]
    }, {
      "featureType": "transit",
      "stylers": [{
        "color": "#808080"
      }, {
        "visibility": "off"
      }]
    }, {
      "featureType": "road.highway",
      "elementType": "geometry.stroke",
      "stylers": [{
        "visibility": "on"
      }, {
        "color": "#b3b3b3"
      }]
    }, {
      "featureType": "road.highway",
      "elementType": "geometry.fill",
      "stylers": [{
        "color": "#ffffff"
      }]
    }, {
      "featureType": "road.local",
      "elementType": "geometry.fill",
      "stylers": [{
        "visibility": "on"
      }, {
        "color": "#ffffff"
      }, {
        "weight": 1.8
      }]
    }, {
      "featureType": "road.local",
      "elementType": "geometry.stroke",
      "stylers": [{
        "color": "#d7d7d7"
      }]
    }, {
      "featureType": "poi",
      "elementType": "geometry.fill",
      "stylers": [{
        "visibility": "on"
      }, {
        "color": "#ebebeb"
      }]
    }, {
      "featureType": "administrative",
      "elementType": "geometry",
      "stylers": [{
        "color": "#a7a7a7"
      }]
    }, {
      "featureType": "road.arterial",
      "elementType": "geometry.fill",
      "stylers": [{
        "color": "#ffffff"
      }]
    }, {
      "featureType": "road.arterial",
      "elementType": "geometry.fill",
      "stylers": [{
        "color": "#ffffff"
      }]
    }, {
      "featureType": "landscape",
      "elementType": "geometry.fill",
      "stylers": [{
        "visibility": "on"
      }, {
        "color": "#efefef"
      }]
    }, {
      "featureType": "road",
      "elementType": "labels.text.fill",
      "stylers": [{
        "color": "#696969"
      }]
    }, {
      "featureType": "administrative",
      "elementType": "labels.text.fill",
      "stylers": [{
        "visibility": "on"
      }, {
        "color": "#737373"
      }]
    }, {
      "featureType": "poi",
      "elementType": "labels.icon",
      "stylers": [{
        "visibility": "off"
      }]
    }, {
      "featureType": "poi",
      "elementType": "labels",
      "stylers": [{
        "visibility": "off"
      }]
    }, {
      "featureType": "road.arterial",
      "elementType": "geometry.stroke",
      "stylers": [{
        "color": "#d6d6d6"
      }]
    }, {
      "featureType": "road",
      "elementType": "labels.icon",
      "stylers": [{
        "visibility": "off"
      }]
    }, {}, {
      "featureType": "poi",
      "elementType": "geometry.fill",
      "stylers": [{
        "color": "#dadada"
      }]
    }], {
      name: 'Styled Map'
    });

    map = new google.maps.Map(document.getElementById('full-map'), {
      zoom: 6,
      center: center,
      streetViewControl: false,
      scrollwheel: false
    });

    markers = [];

    map.mapTypes.set('styled_map', styledMapType);

    map.setMapTypeId('styled_map');

    // GET JSON COLLECT MARKERS

    $('.location-type a[data-type]').on('click', function() {
      $(this).toggleClass('active');

      $('.detailed-info').hide();

      $.each(markers, function(key, marker) {
        marker.setVisible(false);
      })

      // get active types

      var activeTypes = [];
      $('.location-type a[data-type].active').each(function() {
        activeTypes.push($(this).data('type'));
      });

      $.each(markers, function(key, marker) {
        var markerTypes = marker.type.split(',');
        var matchedCount = 0;
        for (i in markerTypes) {
          if(activeTypes.indexOf(markerTypes[i]) == -1 ){
            continue;        
          }
          matchedCount++;
        }
        if(matchedCount == activeTypes.length) {
          marker.setVisible(true);
        }

      })


    });



    $.each(location_data, function(key, val) {

      var locationTitle = location_data[key]['title'];
      var locationAddress = location_data[key]['address'];
      var handle = location_data[key]['handle'];
      var category = location_data[key]['category'];
      var type = location_data[key]['type'];

      var latlng = location_data[key]['latlng'].split(',');
      //latLng = new google.maps.LatLng(data[key].lat, data[key].lng);
      latLng = new google.maps.LatLng(latlng[0], latlng[1]);


      var marker = new google.maps.Marker({
        position: latLng,
        map: map,
        icon: '//cdn.shopify.com/s/files/1/1787/5595/t/1/assets/map-marker.png?latest',
        title: handle,
        category: category,
        type: type
      });

      $.each(markers, function(key, val) {
        if (category == 'open') {
          marker.icon = '//cdn.shopify.com/s/files/1/1787/5595/t/1/assets/map-marker.png?latest'
        } else {
          marker.icon = '//cdn.shopify.com/s/files/1/1787/5595/t/1/assets/map-marker2.png?latest'
        }
      })

      $('.detailed-info').fadeIn();

      marker.addListener('click', function() {
        var clickedType = markers[key]['type'];
        console.log(clickedType);
        var clickedTypes = clickedType.split(',');
        var elementsToFind = [];
        for(i in clickedTypes) {
          elementsToFind.push('a[data-type="' + clickedTypes[i] + '"]');
        }
        console.log(elementsToFind);
        $('.location-type a').removeClass('active');
        $('.location-type').find(elementsToFind.join(',')).addClass('active');
        map.setZoom(8);
        map.panTo(marker.getPosition());
        $('.detailed-info').hide();
        $('.place-name').html(locationTitle);
        $('.place-description').html(locationAddress);
        $('.detailed-info').fadeIn();
        $('.place-info').hide();
      });

      markers.push(marker);

      var locationButton = $('.location-type').find('a')

      // $.each(markers, function(key, val) {

      //     marker = markers[key];

      //     locationButton.on('click', function(e) {

      //         marker.setVisible(false);
      //         if ($(this).hasClass('active')) {
      //             $(this).removeClass('active');
      //             marker.setVisible(true);
      //             map.setZoom(7);
      //             $('.detailed-info').show();

      //         } else {
      //             $(this).addClass('active').siblings().removeClass('active');

      //             map.setZoom(7);
      //             $('.detailed-info').hide();

      //             var dataMarker = $(this).data('marker');
      //             var markerType = $(this).data('type');

      //             if (markerType == type || type.length === 0) {
      //                 marker.setVisible(true);
      //             } 
      //         }
      //     });
      // })
    })

    var geocoder = new google.maps.Geocoder();

    var delay = (function() {
      var timer = 0;
      return function(callback, ms) {
        clearTimeout(timer);
        timer = setTimeout(callback, ms);
      };
    })();

    $('.location-field input').on('keyup', function() {
      delay(function() {
        $('.location-field button').trigger('submit');
      }, 2000);
    });

    // Requested to have first marker clicked by default

    $('.location-field form').on('submit', function(e) {
      e.preventDefault();
      // map.setZoom(2);
      $('.detailed-info').hide();

      $.each(markers, function(key, val) {
        marker = markers[key];
        marker.setVisible(true);
      });

      geocodeAddress($(this), geocoder, map);
    });

    function geocodeAddress(form, geocoder, resultsMap) {

      var address = form.find('#address').val();
      geocoder.geocode({
        'address': address,
        'region': 'Kenya'
      }, function(results, status) {

        if (status === google.maps.GeocoderStatus.OK) {
          // marker.type['user-marker'].setMap(null);
          resultsMap.setCenter(results[0].geometry.location);
          $('.your-location-marker').show();
          console.log(results[0].geometry.location.lat(), results[0].geometry.location.lng());
          
          if(typeof user_marker != "undefined") {
            user_marker.setMap(null);
          }

          user_marker = new google.maps.Marker({
            map: resultsMap,
            icon: '//cdn.shopify.com/s/files/1/1787/5595/t/1/assets/map-marker-user.png?latest',
            position: results[0].geometry.location,
            type: 'user-marker'
          });

          user_marker.setMap(map);
          find_closest_marker(user_marker);

          console.log('marker type',marker.type)

        } else {
          $('.your-location-marker').hide();
          $('.place-info').hide();
        }

      });
    }

    function rad(x) {
      return x * Math.PI / 180;
    }

    function find_closest_marker(user_pos) {

      var bounds = new google.maps.LatLngBounds();

      console.log('bounds',bounds);

      var lat = user_pos.position.lat();
      var lng = user_pos.position.lng();
      var R = 6371; // radius of earth in km
      var distances = [];
      var closest = -1;
      for (i = 0; i < markers.length; i++) {
        var mlat = markers[i].position.lat();
        var mlng = markers[i].position.lng();
        var dLat = rad(mlat - lat);
        var dLong = rad(mlng - lng);
        var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(rad(lat)) * Math.cos(rad(lat)) * Math.sin(dLong / 2) * Math.sin(dLong / 2);
        var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        var d = R * c;
        distances[i] = d;
        if (closest == -1 || d < distances[closest]) {
          closest = i;
        }
      }
      var myLatLng = new google.maps.LatLng(lat, lng);
      bounds.extend(myLatLng);

      var closestLatLng = new google.maps.LatLng(markers[closest].position.lat(), markers[closest].position.lng());
      bounds.extend(closestLatLng);

      // map.setCenter(closestLatLng);

      google.maps.event.trigger(markers[closest], 'click');
      $('.place-info').show();

      map.fitBounds(bounds);
      map.setZoom(map.getZoom() - 1);


    }
  }


  if ($('.full-map').length) {
    initMap();
  }


  // END OF NEW MAP

  // iCheck functionality

  $('input[type="radio"], input[type="checkbox"]').iCheck({
    checkboxClass: 'icheckbox_square',
    radioClass: 'iradio_flat',
    increaseArea: '-10%' // optional
  });

  // Selectric functionality

  $('select.dropdown').selectric();

  // Datepicker (jQuery UI)

  $('.contact-form').find('#date').datepicker({
    minDate: 1,
    maxDate: "+3M",
    firstDay: 1,
    dayNamesMin: ["S", "M", "T", "W", "T", "F", "S"]
  });

  // Test drive form popup

  $('.open-test-drive-mobius-2').click(function(e) {
    e.preventDefault();
    $('.test-drive-mobius-2').fadeIn();
    $('body').addClass('menu-open');
  });

  $('.open-test-drive-mobius-3').click(function(e) {
    e.preventDefault();
    $('.test-drive-mobius-3').fadeIn();
    $('body').addClass('menu-open');
  });


  $('.close-test-drive, .test-drive-overlay, .back-test-drive').click(function() {
    $('.test-drive').fadeOut();
    $('body').removeClass('menu-open');
  })

  // Press items match height  

  $('.press-listing').find('.press-img-wrap').matchHeight();

  // Faq

  // $('.faq-wrap').find('.faq-group:first').find('.faq-question').addClass('faq-open');

  $('.faq-wrap').find('.faq-group').each(function() {
    $(this).find('.faq-question').click(function() {
      $(this).toggleClass('faq-open');
      $(this).parent().siblings().find('.faq-question').removeClass('faq-open');
      $(this).parent().find('.faq-answer').slideToggle();
      $(this).parent().siblings().find('.faq-answer').slideUp();
    });
  })

  // Youtube functionality - gets the cover image of the video and applies as a placeholder of the video

  $('.video-container').each(function() {

    videoSrc = '';

    // YouTube play button functionality

    $(this).find('.play-button').click(function() {

      videoSrc = $(this).parent('.video-container').find(".video-frame").find('iframe').prop('src');
      $(this).fadeOut(500);
      $(this).parent().find('.video-frame', this).addClass('video-visible');

      videoSrc += '&autoplay=1'

      $(this).parent('.video-container').find('iframe').prop('src', videoSrc);

    });
  });

  // Square columns equal height

  $('.squares-content').imagesLoaded(function() {
    $('.squares-content').find('.square-item').matchHeight({
      byRow: true
    })
  });

  // General carousel functionality

  var carouselNav = $('.carousel').find('.carousel-nav').find('li');
  var carouselItem = $('.carousel').find('.carousel-items').find('.carousel-item');

  carouselNav.click(function(u) {
    u.preventDefault();
    $(this).addClass('active').siblings().removeClass('active');
    var navIndex = $(this).index()
    carouselItem.eq(navIndex).fadeIn().siblings().hide();
  });

  $('.view-gallery').click(function(e) {
    e.preventDefault();
    $('.gallery-popup-wrap').fadeIn();

    $('.close-gallery-popup').click(function() {
      $('.gallery-popup-wrap').fadeOut();
    })
  });

  if ($(window).width() > 1024) {
    $('.team-item').matchHeight();

    $('.match-team-inner').matchHeight({
      property: 'max-height',
      target: $('.full-image')
    });
  };

  // E-mail results

  // $('.email-results').on('click', function() {
  //     var emailBody = $('.result-bottom').html();
  //     window.open(" 'mailto:youremail@email.address?subject=subject&body=" + emailBody + "'");
  // })

  $('.request-type').find('input').on('ifChecked', function(event) {
    if ($(this).attr('id') == 'business-request') {
      $('.company-name-wrap').slideDown();
    } else {
      $('.company-name-wrap').slideUp();
    }
  });

});

$(document).ready(function(){

  $('.spec-boxes-wrapper').each(function(){
    $('.extras-content').matchHeight({byRow:false});
    $('.extras-content').find('.spec-title').matchHeight({byRow:false});
    $('.spec-details').matchHeight();
    $('.colour-title-main').matchHeight();
    $('.spec-box .spec-inner:not(".multi-choice")').matchHeight();
    $('.spec-box .spec-inner.multi-choice').matchHeight({byRow:false});
    $('.spec-box').matchHeight();
  });
})